import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import "../../scss/pages/admin/_leloregistration.scss";
import leloContext from "../../context/leloreg/leloContext";
import axios from "axios";
import { getAppUrl } from "../../functions/getEnv";
import setAuthToken from "../../functions/auth_header";
import ErrorLogger from "../../components/ErrorLogger";
import moment from "moment";
import { toast } from "react-toastify";


const NewPreRegistration = () => {
  const navigate = useNavigate();
  const { permalink , LeloRegistrationProfile} = useParams();
  const { formData, onFormDataChange, submitLeloForm, leloDatapermalink, getCoursesByPermalink, age, getAge } =
    useContext(leloContext);
  const {
    charter,
    charter_id,
    siteId,
    gradeLevel,
    courses = [],
    selectedCourseAgreements = [],
    firstName,
    lastName,
    name,
    birthDate,
    studentEmail,
    studentPrimaryPhone,
  } = formData || {};

  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);

  const [searchSites, setSearchSites] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [highSchoolCourses, setHighSchoolCourses] = useState([]);
  const [middleSchoolCourses, setMiddleSchoolCourses] = useState([]);
  const [elementaryCourses, setElementaryCourses] = useState([]);
  const [sessionName, setSessionName] = useState("");
  const [totalCourses, setTotalCourses] = useState("");
  const [gradeLevels, setGradeLevels] = useState([]);
  const [birth, setBirth] = useState(false);

  const learningCenterName = name;
;
  const validateForm = () => {
    const emailError = studentEmail !== "" && !validateEmail(studentEmail);
    const phoneError = studentPrimaryPhone !== "" && !validatePhone(studentPrimaryPhone);

    return !(emailError || phoneError);
  };
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const formatPhoneNumber = (e) => {
    let formattedValue = e.target.value.replace(/\D/g, "");
    if (formattedValue.length > 6) {
      formattedValue = `${formattedValue.slice(0, 3)}-${formattedValue.slice(
        3,
        6
      )}-${formattedValue.slice(6)}`;
    } else if (formattedValue.length > 3) {
      formattedValue = `${formattedValue.slice(0, 3)}-${formattedValue.slice(
        3
      )}`;
    }
    onFormDataChange({
      target: { name: "studentPrimaryPhone", value: formattedValue },
    });
  };

  const validatePhone = (number) =>
    /^(\+?\d{1,3}[- ]?)?\d{3}[- ]?\d{3}[- ]?\d{4}$/.test(number);

  const validateBirthday = (date) => {
    return date && moment(date, "YYYY-MM-DD", true).isValid();
  }

  const handleGradeChange = (e) => {
    onFormDataChange({
      target: { name: "gradeLevel", value: e.target.value },
    });

    onFormDataChange({
      target: { name: "courses", value: [] },
    });
    onFormDataChange({
      target: { name: "selectedCourseAgreements", value: [] },
    });
  };

  const FilledOut =
    charter &&
    formData.selectedLearningCenter &&
    charter_id &&
    firstName &&
    lastName &&
    gradeLevel &&
    validateBirthday(birthDate) &&
    courses[0]?.id;

  const handleCourseChange = (index, courseId) => {
    const { courses: availableCourses } = getCourseInfo();

    if (
      index > 0 &&
      (!courses[index - 1]?.id || courses[index - 1]?.id === "")
    ) {
      toast.error(
        `Please select Course ${index} before selecting Course ${index + 1}`
      );
      return;
    }

    const selectedCourse = availableCourses.find(
      (course) => course._id === courseId
    );
    const updatedCourses = [...courses];
    updatedCourses[index] = {
      id: courseId,
      course_name: selectedCourse ? selectedCourse.course_name : "",
    };
    const updatedAgreements = [...selectedCourseAgreements];
    updatedAgreements[index] = selectedCourse
      ? selectedCourse.master_agreement_name
      : "";
    onFormDataChange({
      target: {
        name: "courses",
        value: updatedCourses,
      },
    });
    onFormDataChange({
      target: {
        name: "selectedCourseAgreements",
        value: updatedAgreements,
      },
    });
  };

  useEffect(() => {
    if (leloDatapermalink?.data && charter_id && learningCenterName && LeloRegistrationProfile) {
      const site = leloDatapermalink.data.filter(
        (v) =>
          v.charter_id === charter_id &&
          learningCenterName.includes(v.learningCenterName) &&
          v.LeloRegistrationProfile === LeloRegistrationProfile
      );
      setTotalCourses(site);
    }
  }, [leloDatapermalink?.data, charter, learningCenterName, LeloRegistrationProfile]);

  useEffect(() => {
    // Set LeloRegistrationProfile in context when component mounts
    if (LeloRegistrationProfile) {
      onFormDataChange({
        target: { name: "LeloRegistrationProfile", value: LeloRegistrationProfile }
      });
    }
  }, [LeloRegistrationProfile]);

  const getCourseInfo = (site) => {
    const filterCoursesByGrade = (courses) =>
      courses.filter((course) =>
        course.grade_level_offered.split(",").includes(gradeLevel)
      );

    let totalCourses1 = 0;
    const siteArray = Array.isArray(site) ? site : [];

    // Get unique siteIds from the site array
    const uniqueSiteIds = [...new Set(siteArray.map(item => item.siteId))];

    if (["TK", "KN", "1", "2", "3", "4"].includes(gradeLevel)) {
      totalCourses1 =
        siteArray
          ?.map((item) => item.elementarySchoolDetails?.totalCourses)
          .filter((value) => value)?.[0] || 0;

      const filteredCourses = filterCoursesByGrade(elementaryCourses);

      return {
        title: "Max Number of Elementary School Courses:",
        courses: filteredCourses,
        key: "elementaryCourses",
        totalCourses1,
        message:
          filteredCourses.length === 0
            ? "No courses available for this grade level"
            : null,
      };
    } else if (["5", "6", "7", "8"].includes(gradeLevel)) {
      totalCourses1 =
        siteArray
          ?.map((item) => item.middleSchoolDetails?.totalCourses)
          .filter((value) => value)?.[0] || 0;

      const filteredCourses = filterCoursesByGrade(middleSchoolCourses);

      return {
        title: "Max Number of Middle School Courses:",
        courses: filteredCourses,
        key: "middleSchoolDetails",
        totalCourses1,
        message:
          filteredCourses.length === 0
            ? "No courses available for this grade level"
            : null,
      };
    } else if (["9", "10", "11", "12"].includes(gradeLevel)) {
      totalCourses1 =
        siteArray
          ?.map((item) => item.highSchoolDetails?.totalCourses)
          .filter((value) => value)?.[0] || 0;

      const filteredCourses = filterCoursesByGrade(highSchoolCourses);

      return {
        title: "Max Number of High School Courses:",
        courses: filteredCourses,
        key: "highSchoolDetails",
        totalCourses1,
        message:
          filteredCourses.length === 0
            ? "No courses available for this grade level"
            : null,
      };
    }

    return {
      title: "",
      courses: [],
      totalCourses1,
      message: "No courses available for this grade level",
    };
  };

  const {
    title,
    courses: availableCourses,
    totalCourses1,
    message,
  } = getCourseInfo(totalCourses);
  const fetchCourses = async () => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }

      // Only fetch courses if we have a specific siteId
      if (siteId && siteId.length > 0 && charter_id && LeloRegistrationProfile) {
        // Use the first siteId for the API call
        const firstSiteId = Array.isArray(siteId) ? siteId[0] : siteId;
        
        const response = await axios.get(`${appUrl}/api/courses/${firstSiteId}/${charter_id}/${LeloRegistrationProfile}`);
        const courses = response.data.filter(
          (course) => course.LeloRegistrationProfile === LeloRegistrationProfile
        );
        console.log("courses", courses);
        setHighSchoolCourses(
          courses.filter((course) => course.course_type === "High School")
        );
        setMiddleSchoolCourses(
          courses.filter((course) => course.course_type === "Middle School")
        );
        setElementaryCourses(
          courses.filter((course) => course.course_type === "Elementary School")
        );
      }
    } catch (error) {
      console.error("Error fetching courses:", error);
      ErrorLogger.logError(error.message);
    }
  };

  useEffect(() => {
    //getCoursesByPermalink(LeloRegistrationProfile);
      getCoursesByPermalink(permalink);
    if (learningCenterName && charter_id) {
      fetchCourses();
    }
  }, [learningCenterName, charter_id]);

  // Add a new useEffect to fetch courses when siteId changes
  useEffect(() => {
    if (siteId && siteId.length > 0 && charter_id && LeloRegistrationProfile) {
      fetchCourses();
    }
  }, [siteId, charter_id, LeloRegistrationProfile]);

  const fetchData = async () => {
    try {
      if (!Array.isArray(leloDatapermalink.data)) {
        setSearchSites([]);
        return;
      }

      const filteredData = leloDatapermalink.data
        .filter((site) => site.LeloRegistrationProfile === LeloRegistrationProfile)
        .map((site, index) => ({
          charter_name: site.charter_name,
          learningCenterName: site.learningCenterName,
          charter_id: site.charter_id,
          permalink: site.permalink,
          LeloRegistrationProfile: site.LeloRegistrationProfile,
          siteId: site.siteId,
        }));

      setSearchSites(filteredData);
    } catch (error) {
      console.error("Error fetching charter and learning center data", error);
      setSearchSites([]);
    }
  };
console.log("searchSites", searchSites);
  useEffect(() => {
    fetchData();
  }, [permalink, leloDatapermalink.data]);

  const getUniqueCharters = (sites) => {
    const seen = new Set();
    return sites.filter((site) => {
      if (seen.has(site.charter_name)) return false;
      seen.add(site.charter_name);
      return true;
    });
  };
  const getUniqueLearningCenters = (charterName, siteIds) => {
    if (!Array.isArray(siteIds)) {
      return [];
    }

    // If no charter is selected, return empty array
    if (!charterName) {
      return [];
    }

    // Filter sites by charter name only, not by siteIds
    const filteredSites = searchSites.filter(
      (site) => site.charter_name === charterName
    );
    
    const uniqueLearningCenters = filteredSites.reduce((acc, site) => {
      if (!acc.some((item) => item.siteId === site.siteId)) {
        acc.push({
          siteId: site.siteId,
          learningCenterName: site.learningCenterName,
        });
      }
      return acc;
    }, []);
    
    return uniqueLearningCenters;
  };

  const handleCharterChange = (e) => {
    const selectedCharter = e.target.value;
    
    const selectedCharterData = searchSites.filter(
      (site) => site.charter_name === selectedCharter
    );
    
    // Get all siteIds for this charter
    const charterSiteIds = selectedCharterData.map(site => site.siteId);
    
    const selectedCharterId =
      selectedCharterData.length > 0 ? selectedCharterData[0].charter_id : "";
    
    // Update form data with charter and maintain LeloRegistrationProfile
    onFormDataChange({ target: { name: "charter", value: selectedCharter } });
    onFormDataChange({ target: { name: "charter_id", value: selectedCharterId }});
    onFormDataChange({ target: { name: "LeloRegistrationProfile", value: LeloRegistrationProfile }});
    onFormDataChange({ target: { name: "siteId", value: [] }}); // Reset siteId to empty array
    onFormDataChange({ target: { name: "selectedLearningCenter", value: "" }}); // Reset selected learning center
    onFormDataChange({ target: { name: "name", value: "" }}); // Reset name
  };

  const handleLearningCenterChange = (e) => {
    const selectedSiteId = e.target.value;
    const selectedCharter = formData.charter;

    // Find the selected site
    const selectedSite = searchSites.find(
      (site) =>
        site.charter_name === selectedCharter &&
        site.siteId === selectedSiteId
    );

    if (selectedSite) {
      onFormDataChange({
        target: { name: "selectedLearningCenter", value: selectedSite.learningCenterName },
      });
      onFormDataChange({
        target: { name: "name", value: selectedSite.learningCenterName },
      });
      onFormDataChange({
        target: { name: "siteId", value: [selectedSite.siteId] },
      });
    }
  };


  const capitalizeFirstLetter = (string) =>
    string ? string.charAt(0).toUpperCase() + string.slice(1) : "";

  useEffect(() => {
    if (permalink) {
      setSessionName(capitalizeFirstLetter(permalink));
    }
  }, [permalink]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    onFormDataChange(e);
  };
  
  useEffect(() => {
    let updatedGrades = [];

    if (highSchoolCourses.length > 0) {
      updatedGrades = [...updatedGrades, "9", "10", "11", "12"];
    }
    if (middleSchoolCourses.length > 0) {
      updatedGrades = [...updatedGrades, "5", "6", "7", "8"];
    }
    if (elementaryCourses.length > 0) {
      updatedGrades = [...updatedGrades, "TK", "KN", "1", "2", "3", "4"];
    }

    // Define the correct grade order
    const gradeOrder = ["TK", "KN", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

    // Sort `updatedGrades` based on `gradeOrder`
    updatedGrades.sort((a, b) => gradeOrder.indexOf(a) - gradeOrder.indexOf(b));

    setGradeLevels(updatedGrades);
  }, [highSchoolCourses, middleSchoolCourses, elementaryCourses]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!FilledOut) {
      setIsSubmitted(true);
      return;
    }
    if (!validateForm()) {
      setIsSubmitted(true);
      return;
    }

    const allFormData = {
      charter: formData.charter,
      charter_id: formData.charter_id,
      name: formData.name,
      gradeLevel: formData.gradeLevel,
      courses: formData.courses,
      firstName: formData.firstName,
      lastName: formData.lastName,
      permaLink: permalink,
      session_name: sessionName,
      selectedCourseAgreements: formData.selectedCourseAgreements,
      birthDate: formData.birthDate,
      studentEmail: formData.studentEmail,
      studentPrimaryPhone: formData.studentPrimaryPhone,
      siteId: formData.siteId.join(", "),
      LeloRegistrationProfile: LeloRegistrationProfile, // Ensure LeloRegistrationProfile is included
    };

    try {
      if (age >= 1 && age <= 100) {
        await submitLeloForm(allFormData);
        toast.success("PreRegistration Form Submitted Successfully");
        await navigate(-1);
        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else if (age < 1 || age > 100) {
        setBirth(true)
      }
    } catch (error) {
      console.error("Error submitting the form:", error.message);
      ErrorLogger.logError(error.message);
      toast.error("There was an issue submitting the form. Please try again later.");
    }
  };

  // Add debugging for the Learning Center dropdown render
  const renderLearningCenterOptions = () => {
    const centers = getUniqueLearningCenters(charter, siteId);
    
    return (
      <>
        <option value="">Please Select</option>
        {centers.map((center, index) => (
          <option
            key={center.siteId ? `${center.siteId}-${index}` : `center-${index}`}
            value={center.siteId}
          >
            {center.learningCenterName}
          </option>
        ))}
      </>
    );
  };

  return (
    <>
      <h1 className="text-center top-title top-title-style">
        New Pre Registration
      </h1>

      <div
        className="right display-back display-back-style"
        onClick={() => {
          navigate(-1);
        }}
      >
        <FaIcons.FaArrowAltCircleLeft className="back-icon" />
        <h4>Back</h4>
      </div>

      <div className="sub-form">
        {isSubmitted && !FilledOut && (
          <p className="validation-msg">Please fill out the required fields</p>
        )}

        <div className="charter-info">
          <div className="item">
            <div className="asterisk-group">
              <h3>Session Name</h3>
            </div>
            <input
              type="text"
              name="sessionName"
              value={sessionName}
              onChange={(e) => setSessionName(e.target.value)}
              disabled
            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                First Name:
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              name="firstName"
              maxLength="50"
              value={firstName || ""}
              required
              onChange={handleChange}
              className={
                isSubmitted && !firstName
                  ? "form-field-error"
                  : "form-field-normal"
              }
            />
          </div>
          <div className="item">
            <div className="asterisk-group">
              <h3>Last Name:</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              name="lastName"
              maxLength="50"
              value={lastName || ""}
              required
              onChange={handleChange}
              className={
                isSubmitted && !lastName
                  ? "form-field-error"
                  : "form-field-normal"
              }
            />
          </div>
          <div className="item">
            <div className="asterisk-group">
              <h3>Birth Date:</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="date"
              name="birthDate"
              max={moment().format("YYYY-MM-DD")}
              onChange={(e) => {
                onFormDataChange(e);
                getAge(moment(e.target.value).utc());
              }}
              value={birthDate}
              className={
                isSubmitted && !birthDate
                  ? "form-field-error"
                  : "form-field-normal"
              }
            />
            {FilledOut && (!birthDate || !validateBirthday(birthDate) || birth) && (
              <p className="validEmail">Please provide a valid date of birth</p>
            )}
            {birthDate && !birth && (
              <p>{`${firstName || "The student"} is ${age} years old? If not, select birth date again`}</p>
            )}
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>Student Email:</h3>
            </div>
            <input
              type="email"
              name="studentEmail"
              maxLength="50"
              value={studentEmail || ""}
              onChange={handleChange}

            />
            {studentEmail !== "" && !validateEmail(studentEmail) && (
              <p className="validEmail">Please provide a valid email address</p>
            )}
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>Student Phone Number:</h3>
            </div>
            <input
              type="text"
              placeholder="XXX-XXX-XXXX"
              name="studentPrimaryPhone"
              value={studentPrimaryPhone}
              maxLength={12}
              onChange={formatPhoneNumber}

            />
            {studentPrimaryPhone !== "" && !validatePhone(studentPrimaryPhone) && (
              <p className="validEmail">
                Please provide a valid phone number in the following format
                XXX-XXX-XXXX
              </p>
            )}
          </div>

          {/* Charter Dropdown */}
          <div className="item">
            <div className="asterisk-group">
              <h3 htmlFor="charter">Charter </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              id="charter"
              name="charter"
              required
              value={charter || ""}
              onChange={handleCharterChange}
              className={
                isSubmitted && !charter
                  ? "form-field-error"
                  : "form-field-normal"
              }
            >
              <option value="">Please Select</option>
              {getUniqueCharters(searchSites).map((site) => (
                <option key={site.charter_id} value={site.charter_name}>
                  {site.charter_name}
                </option>
              ))}
            </select>
          </div>

          {/* Learning Center Dropdown */}
          <div className="item">
            <div className="asterisk-group">
              <h3 htmlFor="learningCenter">Learning Center</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              id="learningCenter"
              name="name"
              required
              value={siteId && siteId.length > 0 ? siteId[0] : ""}
              onChange={handleLearningCenterChange}
              disabled={!charter}
              className={
                isSubmitted && !name ? "form-field-error" : "form-field-normal"
              }
            >
              {renderLearningCenterOptions()}
            </select>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>Grade Level:</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              value={gradeLevel || ""}
              onChange={handleGradeChange}
              className={
                isSubmitted && !gradeLevel
                  ? "form-field-error"
                  : "form-field-normal"
              }
            >
              <option value="">Select Grade Level</option>
              {gradeLevels.length > 0
                ? gradeLevels.map((level) => (
                  <option key={level} value={level}>
                    {level}
                  </option>
                ))
                : null}
            </select>
          </div>

          <div className="item">
            {gradeLevel && ( // Ensure a grade level is selected before showing courses or the message
              <>
                <h4>{title}</h4>
                {message ? (
                  <p style={{ color: "red", fontWeight: "bold" }}>{message}</p>
                ) : (
                  Array.from({ length: totalCourses1 }).map((_, index) => (
                    <div key={index} className="course-item">
                      <h3>Course {index + 1}</h3>
                      <select
                        value={courses[index]?.id || ""}
                        onChange={(e) =>
                          handleCourseChange(index, e.target.value)
                        }
                        className={
                          (index === 0 || !index) &&
                            isSubmitted &&
                            !courses[index]?.id
                            ? "form-field-error"
                            : "form-field-normal"
                        }
                      >
                        <option value="">Select Course</option>
                        {availableCourses
                          .filter(
                            (course) =>
                              !courses.some(
                                (selectedCourse, i) =>
                                  selectedCourse?.id === course._id &&
                                  i !== index
                              )
                          )
                          .map((course) => (
                            <option key={course._id} value={course._id}>
                              {course.course_name}
                            </option>
                          ))}
                      </select>
                      {selectedCourseAgreements[index] && (
                        <p>
                          <b>Agreement:</b>{" "}
                          {selectedCourseAgreements[index]}
                        </p>
                      )}
                    </div>
                  ))
                )}
              </>
            )}
          </div>
        </div>

        {/* Progress Button */}
        <div className="btn-container">
          <input
            type="submit"
            value="Submit"
            className="btn btn-l4l-green submit-button-style"
            onClick={handleSubmit}
          />
        </div>
      </div>
    </>
  );
};

export default NewPreRegistration;




